import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import { useWalletProvider } from "../useWalletProvider";
import { useNavigate } from "react-router-dom";
import { LOGIN_PAGE_URL, SETTINGS_PAGE, INVITATIONS_PAGE } from "../../data/pages";
import settings from "../../assets/media/icons/cog-alt-dark.svg";
import invitations from "../../assets/media/icons/group.svg";
import logout from "../../assets/media/icons/logout.svg";
import FeedbackJsonStorage from "../../utils/feedback/feedbackJsonStorage";
import { AvalancheContext } from "../../avalanche/AvalancheProvider";
import { DwMpcWalletBackendProviderContext } from "../../mpcwalletprovider/DwMpcWalletBackendProvider";
import { collectLog, createEmptyLogsAndVars, dwReportError, } from "../../utils/diagnostics/clientErrors";
export const SelectedWallet = () => {
    const avalancheContext = useContext(AvalancheContext);
    const feedbackJsonStorage = FeedbackJsonStorage.create(avalancheContext);
    const { selectedAccount, disconnectWallet } = useWalletProvider();
    const { storageProps } = useContext(DwMpcWalletBackendProviderContext);
    const [badgeCount, setBadgeCount] = useState(0);
    const [isDark, setIsDark] = useState(true);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const getAccount = async () => {
        const logsAndVars = createEmptyLogsAndVars("SelectedWallet:getAccount");
        try {
            const res = await feedbackJsonStorage.getAllFeedback();
            collectLog(logsAndVars, "getting all feedbacks from Avalanche is done");
            if (res) {
                collectLog(logsAndVars, "starting setBadgeCount");
                setBadgeCount(res.filter((k) => k.feedback.isUnread === true).length);
                collectLog(logsAndVars, "setBadgeCount is done");
            }
        }
        catch (error) {
            dwReportError(selectedAccount, storageProps.portalClientId, error, { logsAndVars });
            console.log(error);
        }
    };
    useEffect(() => {
        if (document.documentElement.getAttribute("data-color-mode") === "dark" ||
            document.documentElement.getAttribute("data-color-mode") === null) {
            setIsDark(true);
        }
        else {
            setIsDark(false);
        }
        getAccount();
    }, []);
    return (_jsx(_Fragment, { children: selectedAccount && (_jsxs("div", { style: { display: "flex", flexDirection: "column", gap: "0px", width: "100%" }, children: [_jsxs("button", { onClick: async () => navigate(SETTINGS_PAGE.url), className: "button subtle large", children: [_jsx("img", { className: "img", alt: "settings", src: settings }), _jsx("div", { className: "text p18x", children: t('common.buttons.settings') })] }), _jsxs("button", { onClick: async () => navigate(INVITATIONS_PAGE.url), className: "button subtle large", children: [_jsx("img", { className: "img", alt: "invitations", src: invitations }), _jsx("div", { className: "text p18x", children: t('common.buttons.invitations') })] }), _jsxs("button", { onClick: async () => {
                        await disconnectWallet();
                        navigate(LOGIN_PAGE_URL);
                    }, className: "button subtle large", children: [_jsx("img", { className: "img", alt: "logout", src: logout }), _jsx("div", { className: "text p18x", children: t('common.buttons.logout') })] })] })) }));
};
